module.exports = __webpack_public_path__ + "img/vote_example_shortlist.1ac32f62.jpg";